import { useContext, useEffect, useState } from "react";
import { Space } from "../Layout";
import { Link } from "react-router-dom";

const Pagination = (props) => {
  const [posts, setPosts] = useState([]);
  const [length, setLength] = useState(0);
  const [all, setAll] = useState(0);
  
  const args = {
    postType: props.postType,
    page: props.page,
    perPage: props.perPage * 3
  }
  
  useEffect(() => {
    fetch(`${tmp_path.site_url}/wp-json/wp/v2/${args.postType}?per_page=${args.perPage}`)
      .then( response => response.json() )
      .then( data => {
        setPosts(data);
        setLength(data.length);
        setAll(data.length / props.perPage);
      })
  }, [])

  const BeforeItem = () => {
    let Items = [];
    for (let i = (Number(args.page) - 1), len = (i - 2); i > len; i--) {
      if(i > 0) {
        Items.push(<Item key={i} active='' index={i} />)
      }
    }
    Items = Items.reverse()
    return(
      <>
        {Items}
      </>
    );
  }

  const AfterItem = () => {
    let Items = [];
    for (let i = Number(args.page), len = all; i < len; i++) {
      if(i <= (Number(args.page) + 1)) {
        Items.push(<Item key={i} active='' index={i + 1} />)
      }
    }
    return(
      <>
        {Items}
      </>
    );
  }

  const Item = (props) => {
    return(
      <>
        <li>
          <Link
            to={`/${args.postType}/page/${props.index}`}
            className="c-pagination__items c-text--en c-text--bold"
            data-state={props.active}
            onClick={(() => {
            })}
          >
            <p className={`c-text__med c-text--bold c-text--en c-text--white ${props.active ? '': 'c-text--white'}`}>
              { props.index }
            </p>
          </Link>
        </li>
      </>
    )
  }

  return(
    <>
      <Space size={['64px auto 0', '48px 0 0']}>
        <div className="l-row">
          <ul className="c-pagination__list">
            <BeforeItem></BeforeItem>
            <Item active='active' to="" index={args.page} />
            <AfterItem></AfterItem>
          </ul>
        </div>
      </Space>
    </>
  )
}

export default Pagination;
